var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_svg__check-8",
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45923 1.54036C7.71307 1.7942 7.71307 2.20575 7.45923 2.45959L3.45923 6.4596C3.20539 6.71344 2.79383 6.71344 2.53999 6.4596L0.53999 4.45959C0.286149 4.20575 0.286149 3.7942 0.53999 3.54036C0.793831 3.28652 1.20539 3.28652 1.45923 3.54036L2.99961 5.08074L6.53999 1.54036C6.79383 1.28652 7.20539 1.28652 7.45923 1.54036Z",
    fill: "currentColor"
  })));
};
export default SvgCheck;